import OrchestratorAPI from './common';

import {
  CombinedEhrInstanceAlert,
  CreateValues,
  EhrInstanceAlert,
  FindAllOptions,
  UpdateValues,
} from '../models/orchestrator/ehrInstanceAlert';

export default class API extends OrchestratorAPI {
  protected readonly API_PATH = '/alert-preferences';

  async findAll(
    options: FindAllOptions = {},
  ): Promise<CombinedEhrInstanceAlert> {
    const url = this.constructPath('/', options);
    return this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<EhrInstanceAlert> {
    const url = this.constructPath(`/${id}`);
    const { alertPreference } = await this.common.getJSON(url);
    return this.deserialize(alertPreference);
  }

  async create(values: CreateValues): Promise<EhrInstanceAlert> {
    const url = this.constructPath('/');
    const { alertPreference } = await this.common.postJSON(url, values);
    return this.deserialize(alertPreference);
  }

  async update(id: string, values: UpdateValues): Promise<EhrInstanceAlert> {
    const url = this.constructPath(`/${id}`);
    const { alertPreference } = await this.common.patchJSON(url, values);
    return alertPreference;
  }

  async remove(id: string): Promise<void> {
    const url = this.constructPath(`/${id}`);
    return this.common.deleteJSON(url);
  }
}
